// extracted by mini-css-extract-plugin
export default {"imgHeader":"SurveyTitle_imgHeader__JaASg","titleContainer":"SurveyTitle_titleContainer__CULXL"};